import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOMES = `${HOME_SERVICE}/account-configs`;

export const accountDrops = {
  getAll: async ({ filters, sort, params, signal, id } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}/categories`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },
  update: async ({
    data,
    toastMessageConfig,
    accountId,
    categoryId,
    dropId,
  }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${accountId}/categories/${categoryId}/drops/${dropId}`,
      headers: { [X_API_VERSION]: API_VERSION },
      method: "put",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
